import React from "react";
import "./Specialization_Banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.css";
// import { Context } from "../../../utils/context";
import Common_Form from "../../../components/common_components/common_form/Common_Form";

const Specialization_Banner = () => {
  return (
    <section className="specialization-banner" id="eligibility">
      <div className="container-fluid p-0">
        <div className="banner-image course_banner_div">
          <>
            <Swiper
              spaceBetween={30}
              pagination={{ clickable: true }}
              // className="mySwiper"
            >
              <SwiperSlide>
                <img
                  rel="preload"
                  loading="lazy"
                  className="ban-img"
                  width="1920"
                  height="700"
                  src="/assets/images/Banner/DPU_Online_BCA.png"
                />
              </SwiperSlide>

              <div className="admission_banner mobile_banner">
                <img
                  src="/assets/images/Banner/Mobile-Banner.png"
                  alt="banner"
                  className="admission_img"
                />
              </div>
            </Swiper>

            <div className="form_holder">
              <Common_Form />
            </div>
          </>
        </div>
      </div>

      <div className="eligibility_strip">
        <div className="eligibility_wrapper">
          <span className="eligibility_label">Eligibility</span>
          <span className="eligibility_text">
            Graduate in any discipline, from a recognized University. Min 50%
            for regular and 45% for category students
          </span>
        </div>
      </div>
    </section>
  );
};

export default Specialization_Banner;
